<template>
  <div class="dhmap-wrapper">
    <div class="mapbox" :class="maph">
      <map-selector ref="mapselector" :param="param" mode="h5"></map-selector>
    </div>
    <div :class="['btnBox','clearfix',isIphoneXr?'changeBottom':'']" v-if="clientType == 'IOS'">
      <a href="javascript:void(0);" class="closeText" @click="closeText">{{ $t('common.cancel')}}</a>
      <a href="javascript:void(0);" class="addText" @click="addText">{{$t('common.save')}}</a>
    </div>
  </div>
</template>

<script>
/*eslint-disable*/
import WKT from "ol/format/WKT";
import mapSelector from "@/components/map/MapSelector";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "selectPosition",
  components: { mapSelector },
  props: {
    selecLeftType: { String },
    selecRightType: { String },
    params: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      param: {},
      maph: "h100",
      changeRightType: "",
      changeLeftType: "",
      isIphoneXr:false,
      clientType: ""
    };
  },
  mounted() {
    this.clientType = getDeviceType();
    this.isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;
    console.log("isIPhoneXR======"+this.isIPhoneXR)
    this.$nextTick(() => {
      this.initPage();
    });
  },
  methods: {
    getPosition() {
      return this.$refs.mapselector.getPosition();
    },
    initPage() {
      if (this.params) {
        this.param.basemap = "all";
        this.param.lon = this.params.lon;
        this.param.lat = this.params.lat;
        console.log(JSON.stringify(this.params))
      }
    },
    addText() {
      let setData = this.getPosition();
      if (this.clientType == "android") {
        if (this.changeRightType == this.$t('common.ok')) {
          this.$emit("setPosition", setData);
          this.changeRightType = "";
        }
      } else {
        this.$emit("setPosition", setData);
      }
    },
    closeText() {
      let setData = "";
      if (this.clientType == "android") {
        if (this.changeLeftType == this.$t('common.goBack')) {
          this.$emit("setPosition", setData);
          this.changeLeftType = "";
        }
      } else {
        this.$emit("setPosition", setData);
      }
    }
  },

  watch: {
    params: {
      handler: function() {
       this.initPage()
      },
      deep: true
    },

    selecLeftType: function(newValue) {
      this.changeLeftType = String(newValue);
      this.closeText();
    },
    selecRightType: function(newValue) {
      this.changeRightType = String(newValue);
      this.addText();
    }
  }
};
</script>

<style lang="less">
.dhmap-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .mapbox {
    width: 100%;
    /* height:50%; */
  }
  .listbox {
    width: 100%;
    /* height:50%; */
    padding: 0px 10px;
    background: #f8f8f8;
    overflow: auto;
  }
  .h50 {
    height: 50%;
  }
  .h100 {
    height: 100%;
  }
  .listbox .ltitle {
    color: #666;
    line-height: 45px;
    font-size: 14px;
    padding-left: 15px;
    border-bottom: 1px solid #e1e1e1;
  }
  /* 暂无数据 */
  .emptybox {
    height: calc(100% - 55px);
    padding-top: 50px;
  }
  .empty {
    /* margin-top: 30px; */
    height: 100px;
    background-image: url("../../../public/empty.png");
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }
  .empty-p {
    margin-top: 15px;
    text-align: center;
    font-size: 14px;
  }
  .btnBox {
    width: 100%;
    height: 45px;
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    border-top: 1px solid #f3f3f3;
    a {
      display: inline-block;
      width: 50%;
      height: 45px;
      line-height: 45px;
      font-size: 14px;
      box-sizing: border-box;
      text-align: center;
    }
    a.closeText {
      border-right: 1px solid #f6f6f6;
      color: #666;
    }
    a.addText {
      color: #36c376;
    }
  }
  // .changeBottom.btnBox{
  //    bottom:30px;
  // }
}
</style>